<template>
<div>
    <div class="timer" :class="{ 'negative-timer': this.countDown < 30}">
        <div class="timer-text">
            {{ this.countDown | prettify }}
            <div class="timer-icon">
                <IconBase
                    :width="16"
                    :height="16"
                    :view-box="`0 0 16 16`"
                    :fill="'#E7E6FA'"
                    class="timer-icon"
                >
                    <IconClockSmall />
                </IconBase>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import moment from 'moment'
import IconBase from '../IconBase'
import IconClockSmall from '../icons/IconClockSmall'

export default {
    name: "Timer",
    props: ['timer', 'propagateEvent'],
    components: {
        IconBase,
        IconClockSmall
    },
    data: function () {
        return {
            countDown: this.calculateCountDown()
        }
    },

    mounted: function () {
        let timer = () => {
            if (this.propagateEvent && this.countDown === 0) {
                this.$store.commit('rooms/timeOut', true);
            }

            // Emit timeout to parent components
            if(this.countDown === 0){
                this.$emit('timeout')
            }

            this.countDown--;
        };

        this.timeIntervalId = setInterval(timer, 1000);

    },

    beforeDestroy() {
        clearInterval(this.timeIntervalId)
    },

    watch: {
        timer(){
            this.countDown = this.calculateCountDown()
        }
    },
    methods: {
        calculateCountDown: function () {
            const meetingStartTime = moment.utc(this.timer.startTime);
            const currentTime = moment.utc();
            let countDown = Math.floor((currentTime - meetingStartTime) / 1000);
            countDown = this.timer.duration - countDown;

            return countDown;
        },
    },

    filters: {
        prettify(countDown) {
            let pad = function (number) {
                return number >= 10 ? number : "0" + number;
            };

            let seconds = pad(Math.abs(Math.trunc(countDown % 60)));
            let minutes = pad(Math.abs(Math.trunc((countDown / 60) % 60)));
            let hours = pad(Math.abs(Math.trunc((countDown / 60 / 60) % 60)));

            let prettyTime =  ( hours == '00' ? '' : ( hours + ':' ) ) + minutes + ":" + seconds;
            return countDown < 0 ? "-" + prettyTime : prettyTime;
        }
    }
}
</script>

<style scoped>
.timer.negative-timer {
    color: red;
}
.timer-text {
    position: relative;
    text-align: left;
    font-size: 16px;
    line-height: 20px;
}
.timer-icon {
    position: absolute;
    top: 1px;
    left: -10px;
}
</style>
